import { RootStore } from 'bzx-common/src/stores'
import { inject, observer } from 'mobx-react'
import React from 'react'

export function ToastNotification(props: any) {
  const rootStore = props.rootStore as RootStore
  const { toastDialog } = rootStore.uiStore
  return (
    <div className={toastDialog.visible ? 'toast-notification--visible' : 'toast-notification'}>
      <i className="txt-center">{rootStore.toastMessage}</i>
    </div>
  )
}

export default inject('rootStore')(observer(ToastNotification))
